<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight p-5 mt-5 item-center justify-center mb-5"
>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-icon
			*ngIf="stateCategory === stateCategories.VALID"
			[spin]="gettingStatus"
			[icon]="ICON.SETTINGS"
			class="text-4xl text-green"
			[testHook]="testHooks.SettingsIcon"
		></app-icon>
		<app-icon
			*ngIf="stateCategory === stateCategories.CANCELLED"
			[spin]="gettingStatus"
			[icon]="ICON.SETTINGS"
			class="text-4xl text-red"
			[testHook]="testHooks.SettingsIcon1"
		></app-icon>
		<app-icon
			*ngIf="stateCategory === stateCategories.WARNING"
			[icon]="ICON.WARNING"
			class="text-4xl text-orange"
			[testHook]="testHooks.WarningIcon"
		></app-icon>
		<p class="text-xl font-bold">{{ state }}</p>
		<p>{{ message }}</p>
	</div>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-button
			[icon]="buttonIcon"
			[loading]="gettingStatus"
			(click)="submit()"
			[testHook]="testHooks.SubmitButton"
			>{{ buttonMessage }}</app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-fct-footer
			(openModal)="_openModal()"
			(cancelOrder)="cancel()"
		></app-fct-footer>
	</div>
</div>
